/**
 * 首頁入口點 - 只載入 App 組件
 * Linus 原則：一頁一入口，按需載入，零混合渲染
 */

import React from 'react'
import { createRoot } from 'react-dom/client'

// 只導入首頁需要的組件
import App from 'components/App'

// 只有存在容器時才掛載組件
const container = document.getElementById('react-app')
if (container) {
  const root = createRoot(container)
  root.render(<App />)
}